import { EPageType } from '@hotelplan/fdr.lib.page.available-pages';

export const FDR_BREADCRUMBS_CAPTIONS = new Map([
  [EPageType.Home, { de: `Home`, fr: `Home` }],
  [EPageType.GeoOverview, { de: `Reiseziele`, fr: `Destinations` }],
  [EPageType.ThemeOverview, { de: `Reiseerlebnisse`, fr: `Expériences` }],
  [EPageType.AgencyOverview, { de: `Reisebüros`, fr: `Agences de voyages` }],
  [EPageType.Srl, { de: `Suchergebnisse`, fr: `Résultats de recherche` }],
]);
